import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { entryRedirectGuard } from './core/guards/entry-redirect.guard';
import { LogLevel, LoggerService } from './core/services/logger.service';
import { GettingStartedComponent } from './tenant/modules/dashboard/components/getting-started/getting-started.component';
import { HelpTopicsComponent } from './tenant/modules/dashboard/components/help-topics/help-topics.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'getting-started',
    pathMatch: 'full',
  },
  {
    path: 'getting-started',
    component: GettingStartedComponent,
    pathMatch: 'full',
    canActivate: [entryRedirectGuard],
  },
  {
    path: 'help-topics',
    component: HelpTopicsComponent,
  },
  {
    path: 'host',
    loadChildren: () => import('./host/host.module').then(m => m.HostModule),
  },
  {
    path: 'tenant',
    loadChildren: () =>
      import('./tenant/tenant.module').then(m => m.TenantModule),
    canActivate: [authGuard],
  },
  {
    path: 'agent',
    loadChildren: () =>
      import('./web-agent/web-agent.module').then(m => m.WebAgentModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule),
  },
  // Fallback when no prior routes is matched
  { path: '**', redirectTo: 'getting-started', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private readonly logger: LoggerService) {
    this.logger.log(LogLevel.TRACE, 'App Routing Module Loads...');
  }
}
